export default __webpack_public_path__ + "static/media/generic.1346bdf4.mp4";